<template>
    <div class="export">
        <el-steps :active="stepActive" finish-status="success" simple class="export-step">
            <el-step :title="$t('xuan_qu_dao_chu_shi_jian_duan')"></el-step>
            <el-step :title="$t('xuan_qu_dao_chu_she_bei')"></el-step>
            <el-step :title="$t('xuan_qu_dao_chu_shu_ju')"></el-step>
        </el-steps>

        <div class="export-time" v-if="stepActive == 1">
            <span class="label">{{$t('dao_chu_shi_jian_qu_jian')}}：</span>
            <el-date-picker
                    size="mini"
                    v-model="makeTimeRange"
                    type="daterange"
                    :picker-options="pickerOptions"
                    :range-separator="$t('zhi')"
                    :start-placeholder="$t('kai_shi_ri_qi')"
                    :end-placeholder="$t('jie_shu_ri_qi')">
            </el-date-picker>

        </div>
        <div class="export-source" v-if="stepActive == 2">
            <el-row class="export-container">
                <el-col :span="11" :offset="1">
                    <p class="export-name">{{$t('xuan_qu_suo_xu_dao_chu_fen_zu')}}</p>
                    <el-transfer
                            :titles="[$t('suo_you_fen_zu'), $t('yi_xuan_fen_zu')]"
                            filterable
                            :filter-method="filterMethod"
                            :filter-placeholder="$t('qing_shu_ru_fen_zu_ming_cheng')"
                            v-model="groups"
                            :data="selectGroups">
                    </el-transfer>
                </el-col>

                <el-col :span="11" :offset="1">
                    <p class="export-name">{{$t('xuan_qu_device')}}</p>
                    <el-transfer
                            :titles="[$t('suo_you_she_bei'), $t('yi_xuan_she_bei')]"
                            filterable
                            :filter-method="filterMethod"
                            :filter-placeholder="$t('qing_shu_ru_she_bei_ming_chen')"
                            v-model="device"
                            :data="selectDevices">
                    </el-transfer>
                </el-col>
            </el-row>
        </div>

        <el-row class="export-items" v-if="stepActive==3">
            <el-col :span="2" class="export-item-sort">
                <ul>
                    <li :class="{active: itemSort==0}" @click="changeItemSort(0)">{{$t('dao_chu_shu_ju')}}</li>
                    <!--<li :class="{active: itemSort==1}" @click="changeItemSort(1)">异常数据</li>-->
                    <!--<li :class="{active: itemSort==2}" @click="changeItemSort(2)">维护数据</li>-->
                </ul>
            </el-col>
            <el-col :span="22" class="export-item-check">
                <el-checkbox :indeterminate="checkItem.isIndeterminate" v-model="checkItem.isAll"
                             @change="handleCheckAllChange">{{$t('quan_xuan')}}
                </el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="checkItem.checkItems" @change="handleCheckedChange">
                    <el-checkbox v-for="item in checkItem.items" :label="item.type" :key="item.type">{{item.name}}
                    </el-checkbox>
                </el-checkbox-group>
            </el-col>
        </el-row>

        <div class="next-step">
            <el-button size="mini" @click="exportPre" v-show="stepActive>1">{{$t('shang_yi_bu')}}</el-button>
            <el-button size="mini" @click="exportNext" v-show="stepActive<3">{{$t('xia_yi_bu')}}</el-button>
            <el-button size="mini" @click="exportData" v-show="stepActive==3">{{$t('dao_chu_shu_ju')}}</el-button>
        </div>

    </div>

</template>

<script>
    import {groupAll} from '@/api/delivery/organization/group'
    import {deviceAll, downloadHistory} from '@/api/delivery/device/list'
    export default {
        name: '',
        components: {},
        mounted: function () {
            let vue = this
            groupAll().then(res => {
                res.data.forEach((group, index) => {
                    vue.selectGroups.push({
                        label: group.name,
                        key: group.uuid,
                    });
                });
            })

            deviceAll().then(res => {
                res.data.forEach((device, index) => {
                    vue.selectDevices.push({
                        label: device.name,
                        key: device.uuid,
                    });
                });
            })
        },
        data: function () {
            return {
                stepActive: 1,
                selectGroups: [],
                groups: [],
                selectDevices: [],
                device: [],

                filterMethod(query, item) {
                    return item.label.indexOf(query) > -1;
                },
                itemSort: 0,
                checkItem: {
                    isIndeterminate: false,
                    isAll: false,
                    checkItems: [],
                    items: [
                        {type: 0, name: this.$t('yin_pin_shu_ju')},
                        {type: 1, name: this.$t('yi_chang_shu_ju')},
//                        {type: 2, name: '饮品制作列表'},
//                        {type: 3, name: '饮品类型统计'},
                    ]
                },

                makeTimeRange: [],
                pickerOptions: {
                    shortcuts: [{
                        text: this.$t('jin_tian'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setHours(0, 0, 0, 0)
                            end.setHours(23, 59, 59, 0)
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                         text: this.$t('zuo_tian'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24);
                            start.setHours(0, 0, 0, 0)
                            end.setTime(end.getTime() - 3600 * 1000 * 24);
                            end.setHours(23, 59, 59, 0)

                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                         text: this.$t('zui_jin_yi_zhou'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                         text: this.$t('zui_jin_yi_yue'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                         text: this.$t('zui_jin_san_yue'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
            }
        },
        methods: {
            exportNext() {
                switch (this.stepActive) {
                    case 1:
                        if (this.makeTimeRange.length === 0) {
                            this.$message.error(this.$t('qing_xuan_qu_dao_chu_shi_jian'))
                            return
                        }
                        break

                    case 2:
                        if (this.groups.length === 0 && this.device.length === 0) {
                            this.$message.error(this.$t('qing_xuan_qu_xu_yao_dao_chu_de_fen_zu_huo_she_bei'))
                            return
                        }
                        break
                }
                if (this.stepActive <= 2) {
                    this.stepActive += 1
                }
            },
            exportPre() {
                this.stepActive -= 1
            },
            exportData () {
                if (this.checkItem.checkItems.length === 0) {
                    this.$message.error(this.$t('qing_xuan_qu_xu_yao_dao_chu_de_shu_ju'))
                    return
                }
                let startAt = parseInt(this.makeTimeRange[0] / 1000)
                let endAt = parseInt(this.makeTimeRange[1] / 1000)
                downloadHistory({
                    startAt: startAt,
                    endAt: endAt,
                    groups: this.groups,
                    devices: this.device,
                    items: this.checkItem.checkItems,
                }).then(function (res) {
                    var downloadElement = document.createElement('a');
                    downloadElement.href = res.data;
//                    downloadElement.download = (new Date()).format('yyyyMMddhhmmss')+'.xlsx'; //下载后文件名
                    downloadElement.download = (new Date()).Format('yyyyMMddhhmmss')+'.xlsx'; //下载后文件名
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); //点击下载
                    document.body.removeChild(downloadElement); //下载完成移除元素
                }).catch(function () {
                })
            },
            changeItemSort (index) {
                this.itemSort = index
            },

            handleCheckAllChange(val) {
                let checkItemsType = []
                this.checkItem.items.forEach(function (item) {
                    checkItemsType.push(item.type)
                })
                this.checkItem.checkItems = val ? checkItemsType : [];
                this.checkItem.isIndeterminate = false;
            },
            handleCheckedChange(value) {
                let checkedCount = value.length;
                this.checkItem.isAll = checkedCount === this.checkItem.items.length;
                this.checkItem.isIndeterminate = checkedCount > 0 && checkedCount < this.checkItem.items.length;
            },

        },
    }
</script>

<style lang="scss">
    .export {
        border: 1px solid $border_sec_color;
        border-radius: .5rem;
        background-color: $bg_sec_color;
        padding: $padding;
        min-height: 30rem;
        .export-step {
            background-color: transparent;
        }

        .el-step__head.is-process {
            color: $f_sec_color;
            border-color: $f_sec_color;
        }

        .el-step__title.is-process {
            color: $f_sec_color;
        }

        .el-step__head.is-success {
            color: $f_color;
            border-color: $f_color;
        }

        .el-step__title.is-success {
            color: $f_color;
        }

        .export-time {
            display: flex;
            justify-content: center;
            text-align: justify;
            align-items: center;
            height: 18rem;
            .label {
                font-size: .8rem;
                font-weight: $w1;
                color: $f_sec_color;
            }
        }

        .export-source {
            height: 24rem;
            .export-container {
                margin: $padding 0;
                .export-name {
                    font-size: .8rem;
                    font-weight: $w1;
                    color: $f_sec_color;
                    text-align: center;
                    margin-bottom: $padding;
                }

                .el-transfer {
                    .el-transfer-panel {
                        background-color: transparent;
                        .el-transfer-panel__header {
                            background-color: transparent;
                            .el-checkbox__label {
                                color: $f_color;
                                font-size: .8rem;
                            }
                        }

                        .el-transfer-panel__body {
                            .el-transfer-panel__filter {
                                .el-input__inner {
                                    border-radius: 0;
                                }
                            }

                            .el-checkbox__label {
                                color: $f_sec_color;
                            }
                        }
                    }
                }
            }

        }

        .export-items {
            height: 24rem;
            .el-col {
                height: 100%;
            }
            .export-item-sort {
                border-right: 1px solid $border_th_color;
                li {
                    font-size: .8rem;
                    padding-bottom: $padding;
                    padding-right: $padding-5;
                    text-align: right;
                    color: $f_sec_color;
                    cursor: pointer;
                }
                li:hover {
                    color: $f_color;
                }
                li.active {
                    color: $f_color;
                }
            }

            .export-item-check {
                padding-left: $padding-5;
                .el-checkbox__label {
                    color: $f_sec_color;
                }
                .el-checkbox {
                    width: 7.5rem;
                    margin-bottom: $padding-5;
                }
            }
        }

        .next-step {
            text-align: center;
            .el-button {
                color: $f_color;
            }
        }
    }
</style>
